module.exports = __webpack_public_path__ + "img/tobi-w38wBWIliw4-unsplash.2531e1d9.jpg";